export enum AssortmentDeviceCategory {
  Deal = 'deal',
}
export enum AssortmentType {
  LatestServer = 'latest_server',
  ServerDeals = 'server_deals',
  Colocation = 'colocation',
  ColocationNetwork = 'colocation_network',
  S3 = 's3',
  Network = 'network',
  Ip = 'ip',
  Cloud = 'cloud',
}
export enum ContactGender {
  NotSpecified = 'not_specified',
  Female = 'female',
  Male = 'male',
  Diverse = 'diverse',
}
export enum IpType {
  Ipv4Address = 'ip_address',
  Ipv4Network = 'ipv4_network',
  Ipv6Network = 'ipv6_network',
}
export enum NotificationType {
  Miscellaneous = 'miscellaneous',
  Maintenance = 'maintenance',
  PriceList = 'price_list',
  Outage = 'outage',
  OrderStart = 'order_start',
  OrderApprovedByCustomer = 'order_approved_by_customer',
  Cancelation = 'cancelation',
  Receipt = 'receipt',
  InvoicePaid = 'invoice_paid',
  AttackStarted = 'attack_started',
  AttackEnded = 'attack_ended',
  InquiryIntakeConfirmation = 'inquiry_intake_confirmation',
}
